module.exports = __webpack_public_path__ + "static/ltc-planning-hero-mobile.67144324.webp";